import { InjectionToken } from '@angular/core';

export const AUCTION_SEALED_FLOW_API_BASE_URL = new InjectionToken<string>('AUCTION_SEALED_FLOW_API_BASE_URL');
